import { MainLayout } from "@/layout";
import { registerRoute } from "@/config/RouteConfig";

const register = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...registerRoute,
      component: () => import("@/views/Register"),
    },
  ],
};

export default register;
